import { Modal, Tag } from "antd";
import Loader from "app/shared/Loader";
import Typography from "app/shared/Typography";
import React, { useEffect, useState } from "react";
//import { API_ENDPOINT_FETCH_RECENT_EMAIL_ACTIVITY } from "../../hotel.booking.constants";
import { apiGet } from "app/services/apiServices";
import { apiPost } from "app/services/apiServices";
import { colorPicker } from "app/utils/color.helper";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import UnsubscribeOutlinedIcon from "@mui/icons-material/UnsubscribeOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import HotelOutlinedIcon from "@mui/icons-material/HotelOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import moment from "moment";
import FlightIcon from "@mui/icons-material/Flight"; // airline icon
import { TagsFilled } from "@ant-design/icons";
import "./ActivityList.scss"


export default function EmailActivityList(props: any) {
    const { applyFilterToTable ,applyTrackingFilter} = props;
    const [emailActivity, setEmailActivity] = useState<any[]>([]);
    const [activityLoading, setActivityLoading] = useState(true);
    const [filterApplied, setFilterApplied] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    useEffect(() => {
        fetchRecentActivity(true); // Initial fetch with loading

        const interval = setInterval(() => {
            fetchRecentActivity(false); // Polling without loading
        }, 120000); // 2 min

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    const fetchRecentActivity = async (showLoader: boolean = false) => {
        if (showLoader) {
            setActivityLoading(true);
        }
        //const response = await apiGet("https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/email_events");
        const response = await apiGet("https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/email_events");
        if (response) {
            setEmailActivity(response.data);
        }
        if (showLoader) {
            setActivityLoading(false);
            setIsInitialLoad(false);
        }
    };

   //function for bulk filter - booking email_ids
    const fetchBulkDetails = async (trackingId: string | string[]) => {
        try {
          const response = await apiPost(
            "https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/mailTrackingSummary",
            {
              trackingId,
            }
          );
      
      
          // Get the comma-separated string of booking IDs
          const idsString = response?.email_bookingIds;
      
          if (typeof idsString === "string" && idsString.trim().length > 0) {

            applyTrackingFilter?.(idsString); 
          } else {
          }
      
          return response.data;
        } catch (error) {
          return [];
        }
      };
      

    const getEventDetails = (eventType: string) => {
        switch (eventType) {
            case "open":
                return {
                    icon: <DraftsOutlinedIcon style={{ fontSize: 16, marginRight: 4, color: colorPicker("primary.700") }} />,
                    label: "Opened",
                    color: colorPicker("primary.700"),
                };
            case "unsubscribed":
                return {
                    icon: <UnsubscribeOutlinedIcon style={{ fontSize: 16, marginRight: 4, color: colorPicker("red.700") }} />,
                    label: "Unsubscribed",
                    color: colorPicker("red.700"),
                };
            default:
                return {
                    icon: <CancelOutlinedIcon style={{ fontSize: 16, marginRight: 4, color: colorPicker("red.700") }} />,
                    label: "Bounced/Dropped",
                    color: colorPicker("red.700"),
                };
        }
    };

    return (
        <div className="MailActivityContainer">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '12px', marginBottom: '8px' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography>
                        Recent Email Activities
                    </Typography>
                    <span className="refreshTxt">(Refresh every 2 min)</span>
                </div>
                <Tag
                    color="red"
                    style={{ fontSize: 12, cursor: "pointer" }}
                    onClick={() => applyFilterToTable?.([])}
                >
                    Remove Filter
                </Tag>
            </div>


            <div className="ActivityList">
                {activityLoading ? (
                    <Loader />
                ) : (
                    emailActivity.map((activity: any, key: number) => {
                        const eventType = activity.latestEvent?.event;
                        const timestamp = activity.latestEvent?.timestamp;
                        const hotelName = activity.email_hotel_name;
                        const airlineName = activity.airline_name;
                        const { icon, label, color } = getEventDetails(eventType);

                        return (
                            <div
                                className="ActivityCard"
                                key={key}
                            // onClick={() => {
                            //     applyFilterToTable?.(activity.email_sharableBookingId || activity.email_bookingId);
                            // }}
                            >
                                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>

                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            {airlineName ? (
                                                <FlightIcon style={{ fontSize: 18, marginRight: 5 }} />
                                            ) : (
                                                <HotelOutlinedIcon style={{ fontSize: 18, marginRight: 5 }} />
                                            )}
                                            <Typography
                                                variant="caption"
                                                style={{ color: colorPicker("neutral.900"), fontWeight: 600 }}
                                            >
                                                {airlineName || hotelName || "N/A"}
                                            </Typography>
                                        </div>
                                        {/* <Tag
                                            color="blue"
                                            style={{ fontSize: 10, marginLeft: 8, cursor: "pointer" }}
                                            onClick={async (e) => {
                                                e.stopPropagation();
                                              
                                                try {
                                                  const bulkData = await fetchBulkDetails(activity.trackingId);
                                              
                                                  if (bulkData) {
                                                    const idsString =
                                                      bulkData.email_sharableBookingIds || bulkData.email_bookingIds;
                                              
                                                    if (typeof idsString === "string") {
                                                      const bookingIds = idsString
                                                        .split(",")
                                                        .map((id: string) => id.trim())
                                                        .filter((id: string) => id.length > 0);
                                              
                                                      // ✅ Apply filter with the available IDs
                                                      applyFilterToTable?.(bookingIds);
                                                    }
                                                  }
                                                } catch (error) {
                                                  console.error("Failed to fetch or process booking IDs", error);
                                                }
                                              }}
                                              
                                        >
                                            Bulk
                                        </Tag> */}
                                        <Tag
                                            color="blue"
                                            style={{ fontSize: 10, marginLeft: 8, cursor: "pointer" }}
                                           
                                            onClick={() => {
                                                fetchBulkDetails(activity.trackingId);  // This will call API and apply filter
                                              }}                                              
                                        >
                                            Bulk
                                        </Tag>


                                    </div>


                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <PersonOutlineOutlinedIcon style={{ fontSize: 18, marginRight: 5 }} />
                                        <Typography
                                            variant="caption"
                                            style={{ color: colorPicker("neutral.900") }}
                                        >
                                            {activity.latestEvent?.email}
                                        </Typography>
                                    </div>


                                    <div
                                        className="TopContent"
                                        style={{ display: "flex", justifyContent: "space-between" }}
                                    >
                                        <div className="Left" style={{ display: "flex", alignItems: "center" }}>
                                            {icon}
                                            <Typography style={{ fontSize: 12, color }}>{label}</Typography>
                                        </div>
                                        <div className="Read" style={{ fontSize: 12, color: "#00000087" }}>
                                            {timestamp ? moment(timestamp * 1000).fromNow() : "N/A"}
                                        </div>
                                    </div>
                                    <Tag
                                        color="cyan"
                                        style={{ fontSize: 10, cursor: "pointer" }}
                                        icon={<TagsFilled />}
                                        onClick={() => {
                                            applyFilterToTable?.(activity.email_sharableBookingId || activity.email_bookingId);
                                        }}
                                    >
                                        {activity.email_sharableBookingId || activity.email_bookingId}
                                    </Tag>



                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
}


